import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { WidgetConfiguration, DataConsumerConfiguration } from '../../../../../interfaces/WidgetInterfaces';
import { DisplayStateService } from '../../../../../services/DisplayStateService';

@Component({
  selector: 'app-widget-config-editor',
  template: `<div class="alert alert-info" role="alert" *ngIf="readonlyWidget">
    <strong>Heads up!</strong> This is a Read Only widget.
</div>
<fieldset [disabled]="readonlyWidget">
    <tabset *ngIf="selectedWidgetConfig" [justified]="true">
        <tab heading="Properties">
            <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Name</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.name" id="name">
                </div>
            </div>
            <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Displayed Name</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.displayName" id="name">
                </div>
            </div>
            <div class="form-group row">
                <label for="description" class="col-sm-2 col-form-label">description</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.description" id="description">
                </div>
            </div>
            <div class="form-group row">
                <label for="componentType" class="col-sm-2 col-form-label">component Type</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.componentType" id="componentType">
                </div>
            </div>
            <div class="form-group row">
                <label for="supportMessage" class="col-sm-2 col-form-label">Support Message</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.supportMessage" id="supportMessage">
                </div>
            </div>
            <div class="form-group row">
                <label for="area" class="col-sm-2 col-form-label">Area</label>
                <div class="col-sm-10">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.area" id="area">
                </div>
            </div>
            <div class="form-group row">
                <label for="supportMessage" class="col-sm-2 col-form-label">Admin Rights Required</label>
                <div class="col-sm-10">
                    <select class="form-control" [(ngModel)]="selectedWidgetConfig.adminRequired">
                        <option [ngValue]="true">True</option>
                        <option [ngValue]="false">False</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label for="widgetAsApp" class="col-sm-2 col-form-label">Run Widget as an App</label>
                <div class="col-sm-10">
                    <select class="form-control" [(ngModel)]="selectedWidgetConfig.widgetAsApp">
                        <option [ngValue]="true">True</option>
                        <option [ngValue]="false">False</option>
                    </select>
                </div>
            </div>
            <div *ngIf="selectedWidgetConfig.widgetAsApp" class="form-group row">
                <label for="widgetSideNavLabel" class="col-sm-2 col-form-label">Internal SideNav Label</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.config.internalSideNavLabel" id="internalSideNavLabel">
                </div>
                <label for="widgetSideNavLabel" class="col-sm-2 col-form-label">Internal SideNav component Type</label>
                <div class="col-sm-4">
                    <input class="form-control" type="text" [(ngModel)]="selectedWidgetConfig.config.internalSideNavComponentType" id="internalSideNavComponentType">
                </div>
            </div>
            <div class="form-group row">
                <label for="config-tags" class="col-sm-2 col-form-label">Tags</label>
                <div class="col-sm-10">
                    <div class="input-group">
                        <input class="form-control" type="text" #newTag (keyup.enter)="AddTag(newTag.value); newTag.value='';" id="config-tags" placeholder="Add Tag - press enter or Add button">
                        <span class="input-group-btn">
                            <input type="button" class="btn btn-success" value="Add" (click)="AddTag(newTag.value); newTag.value='';">
                        </span>
                    </div>
                    <div class="tag-container" *ngIf="selectedWidgetConfig.tags && selectedWidgetConfig.tags.length !== 0">
                        <div class="badge badge-info single-tag" *ngFor="let tag of selectedWidgetConfig.tags">
                            {{tag}}
                            <i (click)="RemoveTag(tag)" class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </tab>
        <ng-template #contextMatchingRulesTooltip>
            <div style="text-align: left;">
                <b>Context Matching:</b> At any time the application can have a set of context name/value pairs. This is called
                the runtime context set. A list of these rules is used to determine if the widget should be shown given the
                state of the context data. For a widget to be displayed, the rules are as follows:
                <ul>
                    <li>Runtime context set has ALL non-optional names defined in the widget's rules</li>
                    <li>If a rule's context value is specified, the runtime context set item by the rule's name has to have that
                        value. If no context value, all that matters is that runtime context set has an item with that name
                    </li>
                    <li>If context has names that aren't specified in the rule, the widget won't be displayed.</li>
                </ul>
            </div>
        </ng-template>
        <tab heading="Context Matching">
            <span class="label label-default" [tooltip]="contextMatchingRulesTooltip" placement="bottom">
                <i class="fa fa-info-circle"></i>&nbsp;Hover for info</span>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label tightPad">Context Name</label>
                <label class="col-sm-4 col-form-label tightPad">Context Value (optional)</label>
                <label class="col-sm-2 col-form-label tightPad">Optional</label>
                <label class="col-sm-1 col-form-label tightPad" tooltip="Default is none, setting this will allow you to click on recent values for this context in the breadcrumb to quickly toggle. The number represents the # of recent values to keep">
                    Hist
                    <i class="fa fa-info-circle"></i>
                </label>
                <label class="col-sm-1 col-form-label tightPad"></label>
            </div>

            <div class="form-group row" *ngFor="let cmr of selectedWidgetConfig.contextMatchingRules; let idx = index">
                <div class="col-sm-4 tightPad">
                    <input type="text" class="form-control" [(ngModel)]="cmr.contextName" name="name">
                </div>
                <div class="col-sm-4 tightPad">
                    <input type="text" class="form-control" [(ngModel)]="cmr.valueMatch" name="value">
                </div>
                <div class="col-sm-2 tightPad">
                    <select class="form-control" [(ngModel)]="cmr.optional">
                        <option [ngValue]="true">True</option>
                        <option [ngValue]="false">False</option>
                    </select>
                </div>
                <div class="col-sm-1 tightPad">
                    <select class="form-control" [(ngModel)]="cmr.historyItemsToKeep">
                        <option [ngValue]="0">None</option>
                        <option [ngValue]="3">3</option>
                        <option [ngValue]="5">5</option>
                    </select>
                </div>
                <div class="col-sm-1 tightPad">
                    <button type="button" class="btn btn-danger btn-sm" (click)="DeleteContextByIndex(idx)">
                        <i _ngcontent-c24="" class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <button type="button" class="btn btn-info btn-sm" (click)="AddContextRule()">
                New context rule
            </button>
        </tab>
        <tab heading="Data">
            <div *ngIf="selectedWidgetConfig.dataConsumerConfigurations">
                <div *ngFor="let dcc of selectedWidgetConfig.dataConsumerConfigurations;let dccIdx = index" class="card p-2 mb-2 row">
                    <app-data-consumer-config-editor [DataConsumerConfig]="dcc">
                    </app-data-consumer-config-editor>
                    <div class="col-1">
                        <button type="button" class="btn btn-danger btn-sm" tooltip="Disassociate Data Policy from widget" (click)="removeConsumerPolicy(dcc,dccIdx)">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedWidgetConfig.dataConsumerConfiguration" class="card p-2 mb-2 row">
                <app-data-consumer-config-editor [DataConsumerConfig]="selectedWidgetConfig.dataConsumerConfiguration">
                </app-data-consumer-config-editor>
            </div>
            <button type="button" class="btn btn-info btn-sm" tooltip="Warning: Widgets with multiple data policies attached require custom logic to handle / load each policy by name."
                (click)="addAnotherConsumerPolicy()">
                <i class="fa fa-plus"></i> Attach another data policy to widget
            </button>
        </tab>
        <tab heading="Configuration">
            <button type="button" class="btn btn-info btn-sm" (click)="UpdateSelectedConfigJson()">
                Save Config Changes
            </button>
            <textarea style="width: 100%; height: 400px" [(ngModel)]="selectedWidgetConfigJson" name="selectedConfigJson"></textarea>
        </tab>
        <tab heading="Raw">
            <pre>{{selectedWidgetConfig | json}}</pre>
        </tab>
        <tab *ngIf="selectedWidgetConfig.componentType == 'GenericWidgetTable'" heading="Table Config">
            <app-generic-table-config [widgetConfig]="selectedWidgetConfig"></app-generic-table-config>
        </tab>
        <tab *ngIf="selectedWidgetConfig.componentType == 'GenericWidgetChart'" heading="Chart Config">
            <app-generic-chart-config [widgetConfig]="selectedWidgetConfig"></app-generic-chart-config>
        </tab>
    </tabset>
</fieldset>`,
  styles: [`.tag-container i{
    margin-left:10px;
    cursor:pointer;
}
.tag-container i:hover{
    color:#640E0E
}
.tag-container .single-tag{
    margin-right:5px;
    padding:5px;
}

.tag-container{
    padding:10px;
    border:1px solid #5bc0de;
    margin-top:5px;
}
`]
})
export class WidgetConfigEditorComponent implements OnInit, OnChanges {

  @Input() selectedWidgetConfig: WidgetConfiguration;

  selectedWidgetConfigJson: string;
  readonlyWidget: boolean = false;

  constructor(private displayStateService: DisplayStateService) { }

  ngOnInit() {
    this.grabJSON();
  }

  canAddAsSideNav() {
    return this.displayStateService.appState.sideNavWidgetConfig !== undefined &&
      this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.findIndex(x => x.name === this.selectedWidgetConfig.name) === -1;
  }

  ngOnChanges() {
    this.grabJSON();
    this.readonlyWidget = this.displayStateService.IsByDefaultWidget(this.selectedWidgetConfig.name);
  }

  AddTag(tag: string) {
    this.selectedWidgetConfig.tags = this.selectedWidgetConfig.tags || [];
    if (tag && this.selectedWidgetConfig.tags.indexOf(tag) === -1) {
      this.selectedWidgetConfig.tags.push(tag);
    };
  }

  RemoveTag(tag: string) {
    this.selectedWidgetConfig.tags.splice(this.selectedWidgetConfig.tags.indexOf(tag), 1);
  }

  UpdateSelectedConfigJson() {

    let newConfig: any;

    try {
      newConfig = JSON.parse(this.selectedWidgetConfigJson);
      this.selectedWidgetConfig.config = newConfig;
      this.grabJSON();
    } catch (e) {
      alert(JSON.stringify(e));
    }

  }

  private grabJSON() {
    this.selectedWidgetConfigJson =
      this.selectedWidgetConfig === undefined || this.selectedWidgetConfig.config === undefined ?
        '' :
        JSON.stringify(this.selectedWidgetConfig.config, null, 2);
  }

  DeleteContextByIndex(idx: number) {

    this.selectedWidgetConfig.contextMatchingRules.splice(idx, 1);
  }

  AddAsSideNav() {
    this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.push(
      {
        name: this.selectedWidgetConfig.name,
        value: this.selectedWidgetConfig.name
      });
  }

  AddContextRule() {
    this.selectedWidgetConfig.contextMatchingRules.push({ contextName: '', optional: true, valueMatch: '' });
  }

  addAnotherConsumerPolicy() {
    // there are some required props needed for an empty one..
    const newDp: DataConsumerConfiguration = {
      dataPolicy: '',
      fixedParameters: [],
      sortColumns: [],
      contextParameters: [],
      filterConfiguration: [],
      overrideCacheRules: { period: undefined },
      dataGrouping: { serverSide: undefined, groupBy: undefined, aggregations: undefined }
    };
    if (this.selectedWidgetConfig.dataConsumerConfigurations) {
      this.selectedWidgetConfig.dataConsumerConfigurations.push(newDp);
    } else {
      const clone = JSON.parse(JSON.stringify(this.selectedWidgetConfig.dataConsumerConfiguration));
      this.selectedWidgetConfig.dataConsumerConfiguration = null;
      this.selectedWidgetConfig.dataConsumerConfigurations = [clone, newDp];
    }
  }
  removeConsumerPolicy(dcc: DataConsumerConfiguration, dccIdx) {
    // Filter the current dcc
    this.selectedWidgetConfig.dataConsumerConfigurations = this.selectedWidgetConfig
      .dataConsumerConfigurations.filter((dc, i) =>  i !== dccIdx);
    if (this.selectedWidgetConfig.dataConsumerConfigurations.length === 1) {
      // if only one is left
      // switch from dataConsumerConfigurations back to dataConsumerConfiguration
      const clone = JSON.parse(JSON.stringify(this.selectedWidgetConfig.dataConsumerConfigurations[0]));
      this.selectedWidgetConfig.dataConsumerConfigurations = null;
      this.selectedWidgetConfig.dataConsumerConfiguration = clone;
    }
  }
}
